/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Star = (props: any) => (
<svg {...props}   viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="32px/star">
<path id="Star 1" d="M16.0001 3.38751L19.489 10.9515C19.7075 11.4252 20.1564 11.7513 20.6745 11.8127L28.9464 12.7935L22.8308 18.449C22.4477 18.8032 22.2763 19.331 22.3779 19.8426L23.3588 19.6478L22.3779 19.8427L24.0013 28.0127L16.7328 23.9441C16.2776 23.6893 15.7227 23.6893 15.2675 23.9441L7.99889 28.0127L9.62227 19.8427C9.72394 19.331 9.55247 18.8032 9.16946 18.449L3.05386 12.7935L11.3257 11.8127C11.8438 11.7513 12.2927 11.4252 12.5112 10.9514L16.0001 3.38751ZM15.5461 2.40318L15.5463 2.40371C15.5462 2.40353 15.5462 2.40336 15.5461 2.40318L16.0001 2.19376L15.5461 2.40318ZM1.9774 12.9211L1.97837 12.921C1.97804 12.9211 1.97772 12.9211 1.9774 12.9211L1.91853 12.4246L1.9774 12.9211ZM24.9472 28.5422L24.9463 28.5417L24.9472 28.5422Z" stroke="#282828" strokeWidth="inherit"/>
</g>
</svg>
);

export default Star;